(function () {
  function getGridRow(root) {
    var section =
      root.closest('[data-section-type="collection-product"]') ||
      root.closest('[data-section-id]') ||
      document;
    return section.querySelector('[data-product-column]');
  }

  function initLoadMore(root) {
    var button = root.querySelector('[data-load-more-button]');
    if (!button || button.dataset.loadMoreBound === 'true') return;

    var progressEl = root.querySelector('[data-load-more-progress]');
    var sectionId = root.dataset.sectionId;
    var gridRow = getGridRow(root);

    if (!gridRow || !sectionId) return;

    button.dataset.loadMoreBound = 'true';

    button.addEventListener('click', function () {
      var nextUrl = root.dataset.nextUrl;
      if (!nextUrl || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      button.disabled = true;

      var fetchUrl = new URL(nextUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load products');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-product-column]');
          var nextLoadMore = doc.querySelector('[data-collection-load-more]');

          if (nextGrid) {
            nextGrid.querySelectorAll('.col').forEach(function (item) {
              gridRow.appendChild(item);
            });
          }

          if (nextLoadMore) {
            root.dataset.shown = nextLoadMore.dataset.shown || root.dataset.shown;
            root.dataset.total = nextLoadMore.dataset.total || root.dataset.total;
            root.dataset.nextUrl = nextLoadMore.dataset.nextUrl || '';

            if (progressEl && nextLoadMore.querySelector('[data-load-more-progress]')) {
              progressEl.textContent = nextLoadMore.querySelector('[data-load-more-progress]').textContent;
            }

            if (!nextLoadMore.dataset.nextUrl) {
              button.remove();
            }
          } else {
            button.remove();
          }
        })
        .catch(function () {
          button.disabled = false;
        })
        .finally(function () {
          button.classList.remove('is-loading');
          if (root.contains(button)) {
            button.disabled = false;
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-collection-load-more]').forEach(initLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('collection:grid-updated', boot);
})();
